import { Card, CardActionArea, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useRouter } from 'next/router'
import React from 'react'

import { Post } from '../../../types/post'
import { urls } from '../../utils/config'
import Image from 'next/image'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '20px auto',
    display: 'flex',
    borderRadius: '0',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'visible',
    minHeight: '430px',
    background: 'transparent',
    transition: 'transform .3s cubic-bezier(0.22, 0.61, 0.36, 1)',
    transform: 'translateY(0)',
    [theme.breakpoints.down('md')]: {},
    '&:hover': {
      cursor: 'pointer',
      transform: 'translateY(-1rem)',
      transition: 'transform .3s cubic-bezier(0.18, 0.89, 0.32, 1.28)',
    },
  },
  actionArea: {
    background: 'transparent',
    '&:hover $focusHighlight': {
      opacity: 0,
    },
  },
  focusHighlight: {},
  button: {
    margin: '20px 20px 0 0',
    width: '304px',
    height: '64px',
    fontSize: '18px',
  },
  authorContainer: {
    display: 'flex',
    flexDirection: 'row',
    margin: '10px 0',
    flexWrap: 'wrap',
    '& h6': {
      fontWeight: 600,
      color: theme.palette.primary.main,
      marginRight: '10px',
    },
  },
  podcastImage: {
    height: '280px',
    width: '100%',
    alignSelf: 'center',
    position: 'relative',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      margin: '10px 0 0 0',
    },
    borderRadius: '16px',
  },
  episode: {
    fontWeight: 600,
    color: theme.palette.primary.main,
    marginBottom: '10px',
  },
  description: {
    margin: '20px 0',
  },
  link: {
    color: theme.palette.primary.main,
    '&:hover': {
      opacity: 0.7,
    },
  },
  title: {
    fontSize: '16px',
    minHeight: '90px',
  },
  textContainer: {
    padding: '10px 0 20px',
  },
}))

interface Props {
  post: Post
}

function PodcastCard({ post }: Props): JSX.Element {
  const classes = useStyles({})
  const { push } = useRouter()
  const goToPodcast = () => push(`${urls.podcast}/${post.slug}`)

  return (
    <Card onClick={goToPodcast} elevation={0} className={classes.root}>
      <CardActionArea
        classes={{
          root: classes.actionArea,
          focusHighlight: classes.focusHighlight,
        }}
        href={`/${post.type}/${post.slug}`}
        disableRipple
      >
        <div className={classes.podcastImage}>
          <Image
            layout="fill"
            objectFit="cover"
            alt={`${post.title} image`}
            src={`${post.podcast_image && post.podcast_image.url}`}
          />
        </div>
        <div className={classes.textContainer}>
          <Typography variant="subtitle2" className={classes.episode}>
            EPISODE {post.episode_number}
          </Typography>
          <Typography variant="h5" className={classes.title}>
            {post.title?.substring(0, 100)}
            {post.title?.length > 100 && '...'}
          </Typography>
        </div>
      </CardActionArea>
    </Card>
  )
}

export default PodcastCard
